/**
 * The two company-profile endpoints, built from an app-supplied API base.
 *
 * Kept as pure functions (no Angular, no DI) because the two apps resolve their base URL
 * differently — the main portal from its own `ConfigService`, the Phoenix portal from
 * `ShellConfigService` — while the PATHS must not fork. Same reasoning as the Phoenix app's
 * `agent-status.util`; it also keeps them unit-testable without bootstrapping anything.
 */

/** `GET /api/companies/me` — the caller's own company (tenant derived from the CompanyId claim). */
export function companyMeUrl(apiUrl: string): string {
  return `${apiUrl}/companies/me`;
}

/** `PUT /api/companies/{companyId}` — partial update of the company settings. */
export function companyUrl(apiUrl: string, companyId: string): string {
  return `${apiUrl}/companies/${companyId}`;
}
